import React from 'react';
import { Button } from '@blueprintjs/core';
import { Link } from 'react-router';
import { validatable } from 'components/utils';
import { DatePicker, Input, InputTuKhoa, DropDown } from 'components/tt-forms/common';
import { ThanhTra } from 'api';
import { ShowIf } from 'components/utils';

let classNames = require('classnames');

class Search extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      linhVucThanhTra: '',
      tienDoThanhTra: '',
      tuNgay: '',
      denNgay: '',
      soQuyetDinh: '',
      searching: this.props.disabled,
      spSearch: false,
      doSearch: false,
      linhVucThanhTraList: []
    }
  }

  componentDidMount() {
    this.getLinhVucThanhTra();
  }

  getLinhVucThanhTra() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({ linhVucThanhTraList: res.data });
      } else {
        this.setState({ linhVucThanhTraList: [] });
      }
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.props.handleSearch(this.state, e);
  }

  componentWillUnmount() {

  }

  cancel(e) {
    this.props.onCancel(e);
    this.resetData();
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searching: nextProps.disabled,
      doSearch: nextProps.search
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  resetData() {
    this.setState({
      linhVucThanhTra: '',
      tienDoThanhTra: '',
      soQuyetDinh: '',
      tuNgay: '',
      denNgay: '',
      searching: false,
      spSearch: false,
      doSearch: false
    });
  }

  render() {
    let classes = ['btn-green', 'tt-search'];

    if (this.state.searching) {
      classes.push('btn-disable');
    }
    if (this.state.doSearch) {
      classes.push('btn-loading');
    }

    let btnClasses = classNames(classes);

    return (
      <form className="search-form" onSubmit={this.handleSearch.bind(this)}>
        <div className={this.props.advanceSearch ? 'col-80 mb15' : ''}>
          <InputTuKhoa
            label="Đối tượng thanh tra/kiểm tra"
            className={this.props.advanceSearch ? 'col-100' : 'input-show'}
            value={this.state.tenDoiTuongThanhTra}
            onChange={this.handleChange.bind(this, 'tenDoiTuongThanhTra')}
            name='tenDoiTuongThanhTra'
            placeholder="Nhập tên đối tượng thanh tra, kiểm tra để tìm kiếm..." />
        </div>

        <div className={this.props.advanceSearch ? 'col-20 mt25 mb15' : "btn-wrap-20"}>
          <Button className={btnClasses} text="Tìm kiếm" type="submit" disabled={this.state.searching ? 'disabled' : ''} />
        </div>
        <ShowIf condition={this.props.advanceSearch}>
          <div className='col-80'>
            <DropDown label="Lĩnh vực" placeholder selectedValue={this.state.linhVucThanhTra} className="col-25" onChange={this.handleChange.bind(this, 'linhVucThanhTra')} name='linhVucThanhTra' options={this.state.linhVucThanhTraList} keyName="giaTri" valueName="ten" />
            <Input label="Số quyết định" value={this.state.soQuyetDinh} className="col-25" onChange={this.handleChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh' placeholder="Nhập..." maxLength={255} />
            <DatePicker className="col-25" label='Quyết định ra từ ngày' bindValidator={this} channel="formTaoDon" endDate={this.state.denNgay} onChange={this.handleChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} />
            <DatePicker className="col-25" label='Đến ngày' bindValidator={this} channel="formTaoDon" startDate={this.state.tuNgay} onChange={this.handleChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} />
          </div>
          <div className="col-20">
            <Link
              className={this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search"}
              onClick={this.cancel.bind(this)}>
              <i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao
            </Link>
          </div>
        </ShowIf>
      </form>
    );
  }
}

Search.defaultProps = {
  validators: {},
  handleSearch: function () {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
}

export default validatable(Search);



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/Search.jsx